/**
 * @format
 * @Description: 手工推送消息详情请求层
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import Request from 'utils/request';
import Cookie from 'js-cookie';
export default class ManuallyDetailServ {
  static getAppList(params) {
    return Request({
      url: `api/user/v1/application/tenant/${Cookie.get('tenant_id')}/instances`,
      method: 'GET',
      data: params
    });
  }
  static saveForm(params) {
    if (params.eventFormData.id) {
      return {
        method: 'put',
        url: 'api/message/v1/event'
      };
    } else {
      return {
        method: 'post',
        url: 'api/message/v1/event'
      };
    }
  }
  static send(params) {
    return {
      method: 'get',
      url: 'api/message/v1/message/list'
    };
  }
  static getListMessageChannel(params) {
    return Request({
      method: 'get',
      url: 'api/message/v1/channel/page',
      data: params
    });
  }
  static getListMessageType() {
    return Request({
      method: 'get',
      url: 'api/message/v1/template/msg-type/page'
    });
  }
  static saveTemplateForm(params) {
    return Request({
      method: 'post',
      url: `api/message/v1/template/relate/event?eventId=${params.eventId}&targetChannels=${params.targetChannels}`,
      data: params.data
    });
  }
  static getEventById(params) {
    return Request({
      url: `api/message/v1/event/${params.id}`,
      method: 'get'
    });
  }
  static getEventUser(params) {
    return Request({
      url: `api/message/v1/event/user/${params.id}`,
      method: 'get',
      data: {
        pageNum: '1',
        pageSize: '10'
      }
    });
  }
  static getUserList(params) {
    return {
      url: 'api/user/v1/user/list',
      method: 'get'
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/MessageManage/ManuallyDetail/ManuallyDetailServ.js